<template>
  <div class="pt-2 d-flex flex-column" style="height:150px; max-height:200px;">
    <!--    ==============================================-->
    <!--    top (headline) -->
    <!--    ==============================================-->
<!--    <center-container class="pa-0 ma-0 d-flex">-->
<!--      <p class="pa-0 ma-0 text-center">-->
<!--        <v-icon v-if="!is_happyness" class="mr-1 mt-n2">mdi-flag</v-icon>-->
<!--        <span class="subtitle-1 mr-0">{{ (activity || {}).name }}</span>-->
<!--      </p>-->
<!--    </center-container>-->
    <!--    ==============================================-->
    <!--    middle (editor) -->
    <!--    ==============================================-->
    <div class="d-flex flex-column my-auto justify-center" >
      <template v-if="is_happyness">
        <template v-if="edit">
          <v-btn-toggle class="mx-auto" v-model="wohlbefinden">
            <v-btn @click="onEmoticonClicked"><v-icon :size="emoticonSize">mdi-emoticon-cry-outline</v-icon></v-btn>
            <v-btn @click="onEmoticonClicked"><v-icon :size="emoticonSize">mdi-emoticon-sad-outline</v-icon></v-btn>
            <v-btn @click="onEmoticonClicked"><v-icon :size="emoticonSize">mdi-emoticon-neutral-outline</v-icon></v-btn>
            <v-btn @click="onEmoticonClicked"><v-icon :size="emoticonSize">mdi-emoticon-happy-outline</v-icon></v-btn>
            <v-btn @click="onEmoticonClicked"><v-icon :size="emoticonSize">mdi-emoticon-outline</v-icon></v-btn>
          </v-btn-toggle>
        </template>
        <template v-else>
          <v-icon :size="emoticonSize*2">{{wohlbefindenIcon}}</v-icon>
        </template>
      </template>
      <template v-else-if="is_bool">
        <template v-if="can_cancel">
          <p v-if="this.value" class="text-center mt-2">
            <v-icon class="mt-n2">mdi-thumb-up</v-icon><span class="headline ml-3">{{ (activity || {}).positiv }}</span>
          </p>
          <p v-else class="text-center mt-5">
            <v-icon class="mt-n2">mdi-thumb-down</v-icon><span class="headline ml-3">{{ (activity || {}).negativ }}</span>
          </p>
          <p class="text-center grey--text body-2">
            {{zielTextMitUnit}}
          </p>
        </template>
        <div v-else style="height:20px" class="d-flex justify-center grey--text body-2">
          {{zielTextMitUnit}}
        </div>
      </template>
      <template v-else-if="is_time">
        <div v-if="edit">
          <div id="tf1_2" class="d-flex justify-center">
            <v-text-field ref="timeTextfield" v-model.number="h" label="Stunden" placeholder=" " type="number" inputmode="decimal" style="max-width: 50px;" class="mr-2"  color="accent" hide-details></v-text-field>
            <v-text-field v-model.number="m" label="Minuten" placeholder=" " type="number" inputmode="decimal" style="max-width: 50px;"  color="accent" hide-details></v-text-field>
          </div>
        </div>
        <div v-else class="d-flex justify-center">
          <div class="display-1 font-weight-light mr-2 d-flex" v-text="timestring"></div>
        </div>
        <div class="d-flex justify-center body-2 mt-1 grey--text" v-text="zielTextMitUnit"></div>
      </template>
      <template v-else>
        <center-container class="pa-0" id="value_box">
          <div id="tf3" class="d-flex flex-row align-baseline" style="height: 50px;">
<!--            <div v-if="!useTextField" class="display-1 font-weight-light mr-2 d-flex" v-text="value||0"></div>-->
            <v-text-field ref="textfield" dense v-model.number="value" style="max-width: 60px;" type="number" inputmode="decimal" color="accent" :readonly="!edit">
            </v-text-field>
            <div class="body-2" v-text="unit()"/>
            <div class="body-2 ml-3 grey--text" v-text="zielText"/>
          </div>
        </center-container>
        <v-row v-if="edit">
          <v-col :cols="12" class="pl-0 mt-n5 d-flex justify-space-around">
            <div v-if="(activity||{}).max > 10" class="d-flex flex-row">
<!--              <v-btn icon small @click="useTextField=!useTextField" class="ml-8">-->
<!--                <v-icon>mdi-form-textbox</v-icon>-->
<!--              </v-btn>-->
<!--              <v-slider-->
<!--                  hide-details-->
<!--                  style="width: 250px;"-->
<!--                  class="my-auto mr-5"-->
<!--                  v-model="value"-->
<!--                  color="gelb"-->
<!--                  track-color="grey"-->
<!--                  always-dirty-->
<!--                  :min="0"-->
<!--                  :max="(activity||{}).max">-->
<!--              </v-slider>-->
            </div>
            <div v-else style="height: 30px;" class="d-flex flex-row" id="rating_container">
<!--                <v-rating v-model="value" :length="(activity||{}).max" hover size="10" id="rating" clearable>-->
<!--                  <template v-slot:item="props">-->
<!--                    <v-icon-->
<!--                        :color="props.isFilled ? 'primary' : 'grey lighten-1'"-->
<!--                        small-->
<!--                        @click="props.click">-->
<!--                      {{ props.isFilled ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}-->
<!--                    </v-icon>-->
<!--                  </template>-->
<!--                </v-rating>-->
            </div>
          </v-col>
        </v-row>
      </template>
<!--      <div style="height: 25px;" v-if="is_bool"></div>-->
    </div>
    <!--    ==============================================-->
    <!--    bottom (ok / edit) -->
    <!--    ==============================================-->
    <div class="d-flex pb-4">
      <v-slide-y-reverse-transition hide-on-leave>
        <v-row justify="center" v-if="edit && show_button" class="pa-0">
          <div class="text-center mr-10" v-if="can_cancel || is_bool">
            <v-btn fab color="grey lighten-2" @click="onCancel" small>
              <v-icon size="25">
                mdi-cancel
              </v-icon>
            </v-btn><br>
            <h6 class="caption mt-3" v-if="is_bool">{{this.activity.negativ}}</h6>
          </div>
          <div class="text-center">
            <v-btn fab color="light-green lighten-2" @click="onSave" small>
              <v-icon size="25">
                mdi-check
              </v-icon>
            </v-btn><br>
            <h6 class="caption mt-3" v-if="is_bool">{{this.activity.positiv}}</h6>
          </div>
        </v-row>
      </v-slide-y-reverse-transition>
      <v-row justify="center" v-if="!edit">
          <v-btn color="gelb" @click="edit=true" :disabled="abgeschlossen">
            <v-icon v-if="!abgeschlossen" size="20" class="mr-2">
              mdi-pen
            </v-icon>
            {{abgeschlossen ? "Tag Abgeschlossen" : "Bearbeiten"}}
          </v-btn>
      </v-row>
    </div>
  </div>
</template>

<script>
import Lib from "@/components/ActivityLibrary";
import Kinds from "@/components/Kinds";

const {DateTime} = require("luxon");
import Activity from "./Activity";
import Datum from "@/components/Datum.js";
import CenterContainer from "@/components/CenterContainer";
import ActivityLibrary from "@/components/ActivityLibrary";
import {formatIntLeadingZeros} from "@/pepper";
import {Ziele} from "@/components/Ziele";

export default {
  name: "ActivityEingabe",
  components: {CenterContainer},
  props: {
    activity: Object,
    activitySums : Object,
    targets: Object,
    date: Date,
    abgeschlossen: Boolean,
  },
  data() {
    return {
      //record:undefined, // { id, date, value }
      value: undefined,
      show_button: true,
      edit: true,
      can_cancel:false,
      is_bool:false,
      useTextField:true,
      is_time: false,
      h: "",
      m: "",
      wohlbefinden: 2,
      emoticonSize:30,
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    focusInput() {
      if (this.is_time && this.$refs.timeTextfield) {
        this.$refs.timeTextfield.focus();
        this.$refs.timeTextfield.$el.querySelector('input').select();
      }
      else if (this.$refs.textfield)
        this.$refs.textfield.focus();
    },
    unit() {
      if (!this.activity)
        return "";
      return "" + (this.activity.unit || "")
    },
    load() {
      if (!this.activity)
        return;
      var record = this.activity.record || {};
      //this.useTextField=false;
      if (record.id)
        this.value = record.value;
      this.edit = !record.id;
      if (this.abgeschlossen)
        this.edit=false;
      this.can_cancel=!!record.id
      if (this.is_happyness) {
        if (record.id)
          this.wohlbefinden= record.value+2;
        else
          this.wohlbefinden=2;
      }
      else {
        this.is_time = (this.activity.unit==="Minuten"||this.activity.unit==="Stunden"||this.activity.unit==="Zeit")
        this.h=0;
        this.m=0;
        if ((this.activity.unit=="Minuten"||this.activity.unit=="Zeit") && this.value) {
          this.h=Math.trunc(this.value / 60);
          this.m=Math.round(this.value % 60);
        }
        else if(this.activity.unit=="Stunden" && this.value) {
          this.h= Math.trunc( this.value);
          this.m= Math.round((this.value-this.h)*60);
        }
        if (this.h===0 && this.m===0){
          this.h="";
          this.m="";
        }
      }
    },
    onEmoticonClicked() {
      this.$nextTick(this.onSave);
    },
    onSave() {
      if (this.is_bool)
        this.value=true;
      this.save();
    },
    async save() {
      if (!this.activity)
        return;
      var date = this.getDateTime();
      var id = Activity.makeRecordId(date.toISODate(), this.activity.id);
      var value = this.value;
      if (this.is_happyness) {
        value=this.wohlbefinden-2;
      }
      else {
        if (this.h==="")
          this.h=0;
        if (this.m==="")
          this.m=0;
        if ((this.activity.unit === "Minuten" || this.activity.unit === "Zeit")) {
          value = this.h * 60 + this.m;
        } else if (this.activity.unit == "Stunden") {
          value = this.h + this.m / 60.0;
        }
      }
      var record = {id, activity: this.activity.id, date: date.toISODate(), value};
      record=await this.$backend.set_object(Kinds.KIND_RECORD, id, record);
      this.$set( this.activity, 'record', record);
      this.load();
      this.$emit("saved", this.activity);
      this.$events.$emit("update_streak");
    },
    getDateTime() {       //  <-- NOTE: this returns a luxon DateTime
      var date = DateTime.fromJSDate(this.date || new Date(Date.now())).startOf('day');
      return date;
    },
    onCancel() {
      this.edit = false;
      if (this.is_bool) {
        this.value = false;
        this.save();
      }
      else
        this.value = this.activity.record.value;
    }
  },
  computed: {
    freq() {
      var a= this.activity;
      if (!a || a.freq === ActivityLibrary.FREQ_DAILY) // pro Tag wird als pro Woche angezeigt!
        return "pro Woche";
      return a.freq;
    },
    zielText() {
      return `(${this.bisJetzt} / ${this.weekTarget} ${this.freq})`;
    },
    zielTextMitUnit() {
      return `(${this.bisJetzt} / ${this.weekTarget} ${this.unit() || 'mal'} ${this.freq})`;
    },
    bisJetzt() {
      var sums=this.activitySums;
      if (!sums)
        return 0;
      var a= this.activity;
      if (!a)
        return 0;
      return Math.round(sums[this.activity.id] || 0);
    },
    targetValues() {
      if (!this.targets)
        return undefined;
      var iso=Datum.today_iso();
      //console.log({iso});
      return new Ziele(this.targets).getTargets(iso);
    },
    weekTarget() {
      var targets=this.targetValues;
      var actiTarget = this.activity.target;
      var aid=this.activity.id;
      //console.log(this.activity.name, targets ? targets[this.activity.id] : "null", "acti:", actiTarget);
      var t=(targets && targets.hasOwnProperty(aid)) ? targets[aid] || actiTarget : actiTarget;
      if (!t)
        t=1;
      if (this.activity.freq === ActivityLibrary.FREQ_DAILY && this.activity.type === ActivityLibrary.TYPE_BOOL)
         return 7;
      if (this.activity.freq === ActivityLibrary.FREQ_DAILY)
        return t * 7;
      else
        return t;
    },
    DatumFormatiert() {
      var dateTime = this.getDateTime();
      // if (this.activity && this.activity.freq == Lib.FREQ_WEEKLY)
      //   return "KW "+ dateTime.weekNumber;
      return dateTime.setLocale('de').toLocaleString({month: 'long', day: 'numeric', weekday: 'short'});
    },
    timestring() {
       return ""+formatIntLeadingZeros(this.h || 0,2)+":"+formatIntLeadingZeros(this.m || 0,2);
    },
    is_happyness() {
      return this.activity && this.activity.id === 'happyness';
    },
    wohlbefindenIcon() {
      var happyness=this.wohlbefinden-2;
      //console.log({happyness});
      if (happyness >= 2)
        return 'mdi-emoticon-outline';
      if (happyness >= 1)
        return 'mdi-emoticon-happy-outline';
      if (happyness >= 0)
        return 'mdi-emoticon-neutral-outline';
      if (happyness >= -1)
        return 'mdi-emoticon-sad-outline';
      if (happyness < -1)
        return 'mdi-emoticon-cry-outline';
      return 'mdi-emoticon-neutral-outline';
    }
  },
  watch: {
    activity: {
      immediate:true,
      handler() {
        //console.log("activity watcher!")
        this.value = undefined;
        this.show_button = false;
        this.load();
        if (this.activity)
          this.is_bool = this.activity.type===ActivityLibrary.TYPE_BOOL;
        setTimeout(() => {
          this.show_button = true;
          this.focusInput();
        }, 200);
      }
    },
  }
}
</script>

<style scoped>

</style>